import { computed } from 'vue';

/**
 * Composable for userless profile state.
 *
 * @param {import('vue').Ref|Function} profile_ref - Ref or getter returning the profile object
 */
export default function useUserlessProfile(profile_ref) {
  const get_profile = typeof profile_ref === 'function' ? profile_ref : () => profile_ref.value;

  const is_userless = computed(() => {
    const profile = get_profile();
    return profile && !profile.attributes.user_id;
  });

  return { is_userless };
}
